import React from 'react'

function Footer() {
    return (
        <div id="footer">
            <div className="container">
                <div className="row">
                    <div className="col-md-3 ">
                        <p>VenueFind</p>
                        <p className="text-justify-center">This booking website is supplied to you by Anita Ewesiobi. For any hiring inquiries, contact Anita Ewesiobi directly through email, phone or linkedin.</p>
                    </div>
                    <div className="col-md-3">
                        <p>Quality Venues</p>
                        <p>Peak Performances</p>
                        <p>Top Service</p>
                        <p>Highly Rated</p>
                    </div>
                    <div className="col-md-3">
                        <p><i className="fas fa-phone-square footer-icon"></i>+1 123 456 789</p>
                        <p><i className="fas fa-phone-square footer-icon"></i>+1 123 456 789</p>
                        <p><i className="fas fa-envelope footer-icon"></i>contact@website.com</p>
                        <p><i className="fas fa-home footer-icon"></i>xyz Road, xyz Complex</p>

                    </div>
                    <div className="col-md-3">
                        <p><i className="fab fa-facebook-f footer-icon"></i>Facebook</p>
                        <p><i className="fab fa-youtube footer-icon"></i>Youtube</p>
                        <p><i className="fab fa-linkedin footer-icon"></i>Linkedin</p>
                        <p><i className="fab fa-twitter footer-icon"></i>Twitter</p>
                    </div>
                </div>
                <hr />
                <p className="copyright text-center"><i className="far fa-copyright"></i> Copyright 2019 Made by Anita Ewesiobi </p>
            </div>
        </div>
    )
}
export default Footer
